module.exports = __webpack_public_path__ + "img/erciyuan.9a35de4a.png";